<template>
  <component :is="analyticplanData === undefined ? 'div' : 'b-card'">
    <!-- Alert: No accountingFile found -->
    <b-alert variant="danger" :show="analyticplanData === undefined">
      <h4 class="alert-heading">Erreur lors de chargement du contenu</h4>
      <div class="alert-body">
        Aucun element trouvé avec cet identifiant. Vérifier
        <b-link class="alert-link" :to="{ name: 'analyticplan-list' }">
          Liste des elements
        </b-link>
        pour les autres element.
      </div>
    </b-alert>

    <data-add-tab
      :analyticplan-data="analyticplanData"
      :defaultanalyticplan-data="defaultanalyticplanData"
      class="mt-2"
    />
  </component>
</template>

<script>
import {
  BTab,
  BTabs,
  BCard,
  BRow,
  BCol,
  BAlert,
  BLink,
  BFormCheckbox,
  BButton,
} from "bootstrap-vue";
import { ref, onUnmounted } from "@vue/composition-api";
import router from "@/router";
import store from "@/store";
import storeModule from "./storeModule";
import DataAddTab from "./FormData.vue";
import Ripple from "vue-ripple-directive";

export default {
  components: {
    BTab,
    BTabs,
    BCard,
    BRow,
    BCol,
    BAlert,
    BLink,
    BFormCheckbox,
    DataAddTab,
    BButton,
    // DataAddTabInformation,
    // DataAddTabSocial,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      operationTitle: "",
      operationIcon: "",
    };
  },
  mounted() {
    if (router.currentRoute.name == "analyticplan-add-new") {
      this.operationTitle = "Ajouter ";
      this.operationIcon = "AddIcon";
    }
    if (router.currentRoute.name == "analyticplan-view") {
      this.operationTitle = "Détails du ";
      this.operationIcon = "EyeIcon";
    }
    if (router.currentRoute.name == "analyticplan-edit") {
      this.operationTitle = "Modification du ";
      this.operationIcon = "EditIcon";
    }
  },
  methods: {
    prevPage() {
      router.push({ name: "analyticplan-list" });
    },
    convertBoolToInt(value) {
      if (value == 1) {
        return true;
      } else {
        return false;
      }
    },
  },
  setup() {
    let analyticplanData = ref(null);
    let APP_STORE_MODULE_NAME = "app-analyticplan";

    // Register module
    if (!store.hasModule(APP_STORE_MODULE_NAME))
      store.registerModule(APP_STORE_MODULE_NAME, storeModule);

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(APP_STORE_MODULE_NAME))
        store.unregisterModule(APP_STORE_MODULE_NAME);
    });

    var defaultanalyticplanData = ref({
      name: "", 
      period: "",
      datestart: "", 
      dateend: "", 
      week: "", 
      notes: "", 
    }); 

    if (router.currentRoute.name == "analyticplan-add-new") {
      // init empty analyticplan data
      analyticplanData = defaultanalyticplanData;
    } else {
      // requirement //
      store
        .dispatch(APP_STORE_MODULE_NAME + "/fetchModule", {
          id: router.currentRoute.params.id,
        })
        .then((response) => {
         var response = JSON.parse(JSON.stringify(response.data));
         response.outcome = JSON.parse(response.outcome)
          console.log('response.outcome.name')
          console.log(response.outcome.name)
          analyticplanData.value = response;
        })
        .catch((error) => {
          console.log(error);
          analyticplanData.value = undefined;
        });
    }

    return {
      analyticplanData,
      defaultanalyticplanData,
    };
  },
};
</script>
